export const CHECKOUT_URL =
  'https://profesor-tecnico-en-electromecanica.impultienda.ar/checkout'

/* Todos los botones e imágenes llevan a la sección de compra */
export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/8cexsamnpxzq5YL6yahacX/Imagen_de_ChatGPT_2_oct_2026,_18_07_17.png'

export const PRODUCT_NAME = 'MEGA PACK PROFESOR TÉCNICO EN AUTOMATIZACIÓN Y PLC'

export const PRICE = '$19.990'
export const BONUS_VALUE = '$39.950'

/* 1. PROBLEMA */
export const problems = [
  {
    icon: 'layers' as const,
    title: 'INFORMACIÓN DISPERSA',
    desc: 'Guardas videos sobre PLC, Ladder, sensores, relés, contactores, motores y automatización, pero cada uno explica algo diferente y no sabes cómo conectar todo.',
  },
  {
    icon: 'question' as const,
    title: 'NO SABES QUÉ APRENDER PRIMERO',
    desc: 'PLC, Ladder, sensores, actuadores, temporizadores, contadores, señales analógicas... hay tantos conceptos y tecnologías que empezar parece complicado.',
  },
  {
    icon: 'route' as const,
    title: 'TE FALTA UNA RUTA',
    desc: 'Quieres aprender una habilidad técnica que pueda ampliar tus posibilidades profesionales, pero necesitas un camino que vaya desde los fundamentos hasta la programación, diagnóstico y proyectos.',
  },
  {
    icon: 'clock' as const,
    title: 'SIGUES POSTERGANDO',
    desc: 'Quieres comenzar, pero pasan las semanas y continúas buscando información en lugar de avanzar con un método organizado.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    icon: 'book' as const,
    title: 'FUNDAMENTOS DE AUTOMATIZACIÓN INDUSTRIAL',
    desc: 'Comprende automatización, electricidad básica, mando y potencia, entradas, salidas, sensores, actuadores y los conceptos fundamentales necesarios antes de comenzar con PLC.',
  },
  {
    icon: 'cpu' as const,
    title: 'PLC DESDE CERO',
    desc: 'Conoce qué es un PLC, cómo funciona, sus entradas y salidas, direccionamiento, ciclo de programa, variables y cómo desarrollar tus primeros automatismos.',
  },
  {
    icon: 'logic' as const,
    title: 'PROGRAMACIÓN Y LÓGICA LADDER',
    desc: 'Aprende contactos, bobinas, lógica AND, OR y NOT, enclavamientos, memorias, temporizadores, contadores, comparadores, alarmas y secuencias automáticas.',
  },
  {
    icon: 'sensor' as const,
    title: 'SENSORES, ACTUADORES Y CONTROL INDUSTRIAL',
    desc: 'Comprende sensores inductivos, capacitivos y fotoeléctricos, señales digitales y analógicas, motores, electroválvulas, cilindros, variadores y su integración con PLC.',
  },
  {
    icon: 'wrench' as const,
    title: 'DIAGNÓSTICO Y RESOLUCIÓN DE FALLAS',
    desc: 'Aprende un método ordenado para localizar problemas siguiendo sensores, entradas, programa, salidas y actuadores hasta encontrar la posible causa de una falla.',
  },
  {
    icon: 'factory' as const,
    title: 'PROYECTO INDUSTRIAL COMPLETO',
    desc: 'Integra todo lo aprendido diseñando, programando, simulando y diagnosticando una automatización con PLC, sensores, actuadores, temporizadores, contadores y alarmas.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    icon: 'dictionary' as const,
    title: 'DICCIONARIO TÉCNICO DE AUTOMATIZACIÓN Y PLC',
    desc: 'Una guía rápida con los términos fundamentales de automatización, PLC, Ladder, sensores, actuadores, señales, temporizadores, contadores, diagnóstico y mantenimiento.',
    value: 'Valor: $7.990',
  },
  {
    icon: 'exercises' as const,
    title: '50 EJERCICIOS DE LÓGICA LADDER',
    desc: '50 ejercicios progresivos para practicar contactos, bobinas, temporizadores, contadores, secuencias, alarmas y automatismos desde nivel básico hasta desafíos integradores.',
    value: 'Valor: $5.990',
  },
  {
    icon: 'search' as const,
    title: 'MANUAL RÁPIDO DE DIAGNÓSTICO DE FALLAS',
    desc: 'Una guía práctica para aprender a seguir el recorrido de la señal, localizar problemas y analizar fallas en sensores, entradas, programa, salidas y actuadores.',
    value: 'Valor: $6.990',
  },
  {
    icon: 'clipboard' as const,
    title: 'PACK DE PLANTILLAS PROFESIONALES',
    desc: 'Plantillas para listas de entradas y salidas, secuencias, programas Ladder, temporizadores, contadores, alarmas, diagnóstico, pruebas y documentación de proyectos.',
    value: 'Valor: $8.990',
  },
  {
    icon: 'projects' as const,
    title: '10 MINI PROYECTOS INDUSTRIALES CON PLC',
    desc: '10 proyectos progresivos para practicar semáforos, puertas automáticas, cintas transportadoras, conteo, tanques, bombas, clasificación, neumática y automatización.',
    value: 'Valor: $9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    icon: 'compass' as const,
    title: 'MENOS CONFUSIÓN',
    desc: 'Deja de saltar entre contenidos y sigue una ruta desde los fundamentos hasta PLC, programación Ladder, sensores, actuadores y diagnóstico.',
  },
  {
    icon: 'wrench' as const,
    title: 'MÁS CONOCIMIENTO PRÁCTICO',
    desc: 'Comprende PLC, Ladder, sensores, actuadores, temporizadores, contadores, señales industriales y automatización con explicaciones organizadas.',
  },
  {
    icon: 'eye' as const,
    title: 'COMPRENDE LO QUE ESTÁS VIENDO',
    desc: 'Empieza a mirar una máquina o proceso automatizado y reconocer qué componentes intervienen, cómo se relacionan y qué función cumple cada uno.',
  },
  {
    icon: 'rocket' as const,
    title: 'UNA NUEVA HABILIDAD',
    desc: 'Construye conocimientos que pueden convertirse en el primer paso para ampliar tus capacidades técnicas y tus posibilidades profesionales.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Había visto muchos videos de PLC y Ladder, pero seguía sin entender cómo se relacionaban las entradas, el programa y las salidas. Con los tomos ordenados finalmente entendí la lógica completa de una automatización.',
    author: 'Diego Fernández',
    role: 'Técnico en formación, 29 años',
    location: 'Rosario, Argentina',
  },
  {
    quote:
      'Lo que más me ayudó fue entender que no todo es programar Ladder. Hay que comprender sensores, actuadores, secuencias y condiciones antes de comenzar a programar. Ahora puedo analizar un automatismo con mucho más orden.',
    author: 'Marcelo Ibáñez',
    role: 'Técnico electricista, 41 años',
    location: 'Córdoba, Argentina',
  },
  {
    quote:
      'Trabajo con electricidad y quería sumar automatización, pero no sabía qué estudiar primero. El sistema me ayudó a conectar la parte eléctrica con PLC, sensores, relés, contactores y actuadores.',
    author: 'Laura Quiroga',
    role: 'Electricista, 35 años',
    location: 'Montevideo, Uruguay',
  },
  {
    quote:
      'Entré buscando aprender PLC y terminé entendiendo también diagnóstico. El método de seguir sensor, entrada, programa, salida y actuador me ayudó a pensar una falla de una manera mucho más ordenada.',
    author: 'Cristian Molina',
    role: 'Técnico independiente, 32 años',
    location: 'Santiago, Chile',
  },
  {
    quote:
      'Quería aprender algo nuevo que pudiera complementar mi trabajo técnico. Los ejercicios, las plantillas y los proyectos me dieron una estructura mucho más clara para practicar en lugar de seguir mirando contenido sin un orden.',
    author: 'Héctor Ramírez',
    role: 'Técnico de mantenimiento, 48 años',
    location: 'Guadalajara, México',
  },
]

/* 6. FAQ */
export const faqs = [
  {
    q: '¿Es físico o digital?',
    a: 'Es un producto 100% digital.',
  },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El sistema comienza desde los fundamentos y avanza progresivamente hacia PLC, programación Ladder, sensores, actuadores, diagnóstico y proyectos.',
  },
  {
    q: '¿Qué voy a aprender?',
    a: 'Aprenderás fundamentos de automatización, funcionamiento de PLC, programación Ladder, sensores, actuadores, señales industriales, temporizadores, contadores, diagnóstico y desarrollo de proyectos.',
  },
  {
    q: '¿Incluye ejercicios?',
    a: 'Sí. Incluye actividades prácticas, ejercicios Ladder, casos de diagnóstico y proyectos para aplicar los conceptos aprendidos.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos están incluidos con tu compra durante esta oferta.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Realizas un único pago y no tienes mensualidades.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. Al tratarse de un producto digital, recibirás acceso según las instrucciones proporcionadas después de completar tu compra.',
  },
  {
    q: '¿Esto me habilita profesionalmente?',
    a: 'No. Es un producto educativo y no sustituye certificaciones, licencias, formación oficial, experiencia práctica ni requisitos profesionales que puedan corresponder.',
  },
  {
    q: '¿Puedo aprender a mi ritmo?',
    a: 'Sí. Puedes avanzar siguiendo los tomos y realizar las prácticas según tu propio ritmo de aprendizaje.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Puedes utilizar el canal de soporte indicado después de tu compra.',
  },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Martín Gómez', city: 'Córdoba', minutes: 3 },
  { name: 'Lucía Ferreyra', city: 'Rosario', minutes: 6 },
  { name: 'Pablo Sosa', city: 'Buenos Aires', minutes: 9 },
  { name: 'Andrés Medina', city: 'Mendoza', minutes: 13 },
  { name: 'Sofía Ledesma', city: 'La Plata', minutes: 17 },
  { name: 'Javier Rossi', city: 'Mar del Plata', minutes: 21 },
  { name: 'Nicolás Barrios', city: 'Salta', minutes: 26 },
  { name: 'Camila Vera', city: 'San Miguel de Tucumán', minutes: 31 },
]
